import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'
import UUID from "vue-uuid";

Vue.use(UUID);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  store,
  created: function() {
    window.amplitude.getInstance().logEvent('Shop Viewed', { device_id: 'value', timestamp: new Date() })
  }
}).$mount('#app')

